import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=1f022f6f&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=1f022f6f&prod&lang=css"
import style1 from "./BaseLayout.vue?vue&type=style&index=1&id=1f022f6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f022f6f",
  null
  
)

export default component.exports